<template>
	<v-app id="app">
		<v-content class="main-bg" fill-height>
			<v-container :class="[getActualStep == 1 ? 'pt-5' : '']">
				<v-layout :class="[this.$route.name == 'Step1' ? 'layout-header' : '']" align-center justify-center>
					<v-flex class="flex-logo">
						<img :class="['logo', this.$route.name == 'Step1' ? 'logo-front' : '']"
						src="../src/assets/logo.png">
					</v-flex>
					<v-flex class="flex-title" v-if="this.$route.name == 'Step1'">
						<div class="display-1 yellow--text bold--text" v-if="getStore() == 23">SUP - Pardubice</div>
						<div class="display-1 yellow--text" v-if="getStore() == 24">SUP - Hradec Králové</div>
						<a href="http://rezervace.sup-hradec.cz" class="white--text" v-if="getStore() == 23" color="white">Přejít na pobočku Hradec Králové</a>
						<a href="http://rezervace.sup-pardubice.cz" class="white--text" v-if="getStore() == 24" color="white">Přejít na pobočku Pardubice</a>
					</v-flex>
				</v-layout>
			</v-container>
			<v-container v-if="this.$route.name != 'Step1' && this.$route.name != 'Calendar'  && this.$route.name != 'FastSelect1' && this.$route.name != 'FastSelect2'" class="pa-0">
				<v-stepper non-linear @input="setStep" :value="getActualStep">
					<v-stepper-header>
						<v-stepper-step step="1" :complete="getActualStep > 1" :editable="getActualStep > 1">
							Výběr služby
						</v-stepper-step>
						<v-divider></v-divider>
						<v-stepper-step step="2" :complete="getActualStep > 2" :editable="getActualStep > 2">
							Upřesnění objednávky
						</v-stepper-step>
						<v-divider></v-divider>
						<v-stepper-step step="3" :complete="getActualStep > 3" :editable="getActualStep > 3">
							Informace o uživateli
						</v-stepper-step>
						<v-divider></v-divider>
						<v-stepper-step step="4" :complete="getActualStep > 4" :editable="getActualStep > 4">
							Výběr metody platby
						</v-stepper-step>
						<v-divider></v-divider>
						<v-stepper-step step="5" :complete="getActualStep > 5">Shrnutí objednávky</v-stepper-step>
					</v-stepper-header>
				</v-stepper>
			</v-container>
			<v-container>

				<router-view/>
        <Footer></Footer>

			</v-container>
		</v-content>
	</v-app>
</template>

<script>
	import {mapGetters} from 'vuex'
  import Footer from '@/components/Footer'

			export default {
				name: 'App',
        components: {
          Footer
        },
				data() {
					return {
						visible: true,
					}
				},
				mounted() {

				},

				computed: {
					...mapGetters([
							'getActualStep',
					]),
				},
				methods: {
					setStep(step) {
//                this.visible = false;
//                this.$nextTick(() => {
//                    this.visible = true
//                });
						this.$store.commit('setActualStep', step);
						this.$router.push('step-' + step);
					},
                    getStore() {
                        if(window.location.hostname === 'rezervace.sup-pardubice.cz') {
                            return 23;
                        } else if (window.location.hostname === 'rezervace.sup-hradec.cz') {
                            return 24;
                        } else {
                            return $cookies.isKey("STORE_COOKIE") && $cookies.get("STORE_COOKIE") === 'hk' ? 24 : 23;
                        }
                    }
				},
			}
</script>



// WEBPACK FOOTER //
// src/App.vue